import { render, staticRenderFns } from "./adSourcing.vue?vue&type=template&id=d0d54034&scoped=true"
import script from "./adSourcing.vue?vue&type=script&lang=js"
export * from "./adSourcing.vue?vue&type=script&lang=js"
import style0 from "./adSourcing.vue?vue&type=style&index=0&id=d0d54034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d54034",
  null
  
)

export default component.exports